@for (tag of filterFieldTags; track tag; let i = $index) {
  <mat-chip (removed)="handleRemove(tag.name)" [attr.id]="'filter-tag-chip-' + i" style="width: fit-content;">
    <span style="font-weight: 500; padding-right: 4px;">{{ tag.label }}:</span><span>{{ tag.value }}</span>
    <button matChipRemove [attr.id]="'filter-tag-btn-remove-' + i">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
}
